import useNotification from "../hooks/useNotification";
import NotificationList from "../components/NotificationList";
import NotificationDrawer from "../components/NotificationDrawer";

const NotificationListContent = () => {
    const hook = useNotification();

    return (
        <>
            <NotificationList
                notificationList={hook.notificationList}
                isLoading={hook.isLoading}
                onCreate={hook.onCreate}
                onEdit={hook.onEdit}
                onDelete={hook.onDelete}
                onStatus={hook.onStatus}
            />
            <NotificationDrawer
                open={hook.drawerOpen}
                record={hook.editingRecord}
                templateOptions={hook.templateOptions}
                emailLoopOptions={hook.emailLoopOptions}
                onCancel={hook.onCloseDrawer}
                onSubmit={hook.onSubmit}
            />
        </>
    );
};

export default NotificationListContent;